import React from 'react';
import once from 'lodash/once';

import type { FormPropsChildren } from './form.types';

export interface FormContextType<Schema> {
  getSchemaProperty: (propName: string) => SchemaDefinitionProperty;
  fireReset: FormPropsChildren<Schema>['fireReset'];
  fireSubmit: FormPropsChildren<Schema>['fireSubmit'];
  fireChange: FormPropsChildren<Schema>['fireChange'];
  setFieldTouched: FormPropsChildren<Schema>['setFieldTouched'];
  setValues: FormPropsChildren<Schema>['setValues'];
  values: Schema | null;
}

export const invokeFormContext = once(<Schema,>() =>
  React.createContext<FormContextType<Schema>>({
    getSchemaProperty: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    fireReset: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    fireSubmit: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    fireChange: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    setFieldTouched: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    setValues: () => {
      throw new Error(
        "You're outside a form context. This won't work as expected"
      );
    },
    values: null,
  })
);

export const useFormContext = <Schema = unknown,>() => {
  return React.useContext<FormContextType<Schema>>(invokeFormContext<Schema>());
};
